import React from 'react';

import Icon from './Icon';

const IconWarranty = (props) => {
    return (
        <Icon width='50' height='50' {...props}>
            <g fillRule='nonzero' fill='none'>
                <path
                    d='m24.87 2.188 20.755 4.374h-.002.002v13.25c-.007 12.303-6.866 21.636-20.577 28l-.048-.15-.048.15C11.406 41.526 4.548 32.34 4.378 20.256l-.003-.444V6.562h.002-.002l20.496-4.375z'
                    stroke='#34303D'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='m25.032 6.25 16.332 3.53v10.693c-.119 9.78-5.413 17.234-15.884 22.364l-.48.231V6.257l.032-.007z'
                    fill='#00D1D2'
                />
                <path
                    stroke='#34303D'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='m17.49 24.901 5.184 4.758 12.208-12.422'
                />
            </g>
        </Icon>
    );
};

export default IconWarranty;
